FansMdl.config( [ '$stateProvider', '$urlRouterProvider', function( $stateProvider, $urlRouterProvider) {



	$urlRouterProvider.when('', ['$state', function ( $state ) {
		$state.go( 'main.categories.families.colors' );
	}]);


	$stateProvider

		.state('main', {
			abstract: true,
			views: {
				'mobile-filters': {
					templateUrl: 'Filters/Mobile-Filters/Views/_mobile-filter.tpl.html',
					controller: 'MobileCtrl as mobile'
				},
				'search' : {
					templateUrl: 'Filters/Search/Views/_Search.tpl.html',
					controller: 'SearchCtrl as search'
				},
				'filters': {
					templateUrl: 'Filters/Main/Views/_Filters.tpl.html',
					controller: 'FiltersCtrl as filters'
				}
			},
			onEnter: ['RedirectSrv', function( RedirectSrv ){
				RedirectSrv.setRedirect();
			}],
		})

		.state('main.categories', {
			abstract: true,
			url: '/category/:category_slug',
			params: {
				category_slug: 'wall'
			},
			views: {
				'categories': {
					templateUrl: 'Filters/Categories/Views/_categories.tpl.html',
					controller: 'CategoriesCtrl as categories'
				},
				'inner-filters': {
					templateUrl: 'Filters/Main/Views/_inner-filters.tpl.html',
					controller: 'InnerFiltersCtrl as inner_filters'
				}
			},
			resolve: {
				categories:	[ 'CategoriesSrv', function( CategoriesSrv ) {
					return CategoriesSrv.getCategories();
				}],
				category: [ '$stateParams', 'UtilsSrv', 'categories', function( $stateParams, UtilsSrv, categories ){
					return UtilsSrv.getFilterObj( categories, $stateParams.category_slug);
				}]
			}

		})

		.state( 'main.categories.families', {
			abstract: true,
			url: '/family/:family_slug',
			params: {
				family_slug : null
			},
			views: {
				'families@main.categories': {
					templateUrl: 'Filters/Families/Views/_families.tpl.html',
					controller: 'FamiliesCtrl as families'
				}
			},
			resolve: {
				families: ['FamiliesSrv', function( FamiliesSrv ) {
					return FamiliesSrv.getFamilies();
				}],
				family: [ '$stateParams', 'UtilsSrv', 'families', function( $stateParams, UtilsSrv, families ){
					return $stateParams.family_slug ? UtilsSrv.getFilterObj( families, $stateParams.family_slug) : null;
				}]
			}
		})

		.state( 'main.categories.families.colors', {
			url: '/color-fan/:color_fan_slug',
			params: {
				color_fan_slug: {
					value: null,
					squash: true
				}
			},
			views: {
				'color-fans@main.categories': {
					templateUrl: 'Filters/Color-Fans/Views/_color-fans.tpl.html',
					controller: 'ColorFansCtrl as color_fans'
				},
				'the-fans@': {
					templateUrl: 'Hues/Main/Views/_the-fans.tpl.html',
					controller: 'FansCtrl as fans'
				},
				'breadcrumbs@main.categories.families.colors': {
					templateUrl: 'Hues/Breadcrumbs/_breadcrumbs.tpl.html',
					controller: 'BreadcrumbsCtrl as breadcrumbs'
				},
				'save-fan@main.categories.families.colors': {
					templateUrl: 'Hues/Save-Fan/Views/_save-fan.tpl.html',
					controller: 'SaveFanCtrl as save'
				},
				'hues@main.categories.families.colors': {
					templateUrl: 'Hues/Main/Views/_hues.tpl.html',
					controller: 'HuesCtrl as hues'
				}
			},
			resolve: {
				hide: ['category', function( category ){
					return ( category.filter_through === 'categories-select' );
				}],
				color_fans: ['ColorFansSrv', 'category', function( ColorFansSrv, category ) {
					return ColorFansSrv.getColorFansByProductCat( category.id );
				}],
				color_fan: [ '$stateParams', 'UtilsSrv', 'color_fans', function( $stateParams, UtilsSrv, color_fans ){
					return $stateParams.color_fan_slug ? UtilsSrv.getFilterObj( color_fans, $stateParams.color_fan_slug) : null;
				}],
				effect_fan: [function(){ return false; }]
			}
		})


		.state('main.categories.families.effects',{
			url: '/effect-fan/:effect_fan_slug',
			params: {
				effect_fan_slug: {
					value: null
				}
			},
			views: {
				'effect@main.categories' : {
					templateUrl: 'Filters/Effect-Fans/Views/_effect-fans.tpl.html',
					controller: 'EffectFans as effect_fans'
				},
				'the-fans@': {
					templateUrl: 'Hues/Main/Views/_the-fans.tpl.html',
					controller: 'FansCtrl as fans'
				},
				'breadcrumbs@main.categories.families.effects': {
					templateUrl: 'Hues/Breadcrumbs/_breadcrumbs.tpl.html',
					controller: 'BreadcrumbsCtrl as breadcrumbs'
				},
				'save-fan@main.categories.families.effects': {
					templateUrl: 'Hues/Save-Fan/Views/_save-fan.tpl.html',
					controller: 'SaveFanCtrl as save'
				},
				'hues@main.categories.families.effects': {
					templateUrl: 'Hues/Main/Views/_hues.tpl.html',
					controller: 'HuesCtrl as hues'
				}
			},
			resolve: {
				hide: ['category', function( category ){
					return ( category.filter_through === 'categories-select' );
				}],
				effect_fans: ['EffectFansSrv', 'category', function( EffectFansSrv, category ) {
					return EffectFansSrv.getEffectFans( category.id );
				}],
				effect_fan: [ '$stateParams', 'UtilsSrv', 'effect_fans', function( $stateParams, UtilsSrv, effect_fans ){
					return $stateParams.effect_fan_slug ? UtilsSrv.getFilterObj( effect_fans, $stateParams.effect_fan_slug ) : null;
				}],
				color_fan: [function(){ return false; }]
			}
		})

		.state('main.categories.families.effects.colors',{
			url: '/color-fan/:color_fan_slug',
			params: {
				color_fan_slug: {
					value: null
				}
			},
			views: {
				'color-fans@main.categories': {
					templateUrl: 'Filters/Color-Fans/Views/_color-fans.tpl.html',
					controller: 'ColorFansCtrl as color_fans'
				},
				'the-fans@': {
					templateUrl: 'Hues/Main/Views/_the-fans.tpl.html',
					controller: 'FansCtrl as fans'
				},
				'breadcrumbs@main.categories.families.effects.colors': {
					templateUrl: 'Hues/Breadcrumbs/_breadcrumbs.tpl.html',
					controller: 'BreadcrumbsCtrl as breadcrumbs'
				},
				'save-fan@main.categories.families.effects.colors': {
					templateUrl: 'Hues/Save-Fan/Views/_save-fan.tpl.html',
					controller: 'SaveFanCtrl as save'
				},
				'hues@main.categories.families.effects.colors': {
					templateUrl: 'Hues/Main/Views/_hues.tpl.html',
					controller: 'HuesCtrl as hues'
				}


			},
			resolve: {
				effect_fan: ['$stateParams', 'UtilsSrv', 'effect_fans', function( $stateParams, UtilsSrv, effect_fans ){
					return UtilsSrv.getFilterObj( effect_fans, $stateParams.effect_fan_slug );
				}],
				color_fans: ['ColorFansSrv', 'effect_fan', function( ColorFansSrv, effect_fan ) {
					return ColorFansSrv.getColorFansByEffectFan( effect_fan.id );
				}],
				color_fan: [ '$stateParams', 'UtilsSrv', 'color_fans', function( $stateParams, UtilsSrv, color_fans ){
					return $stateParams.color_fan_slug ? UtilsSrv.getFilterObj( color_fans, $stateParams.color_fan_slug) : null;
				}]
			}

		})

		.state('main.categories.subcategories',{
			url: '',
			onEnter: ['HuesUpdaterSrv', function( HuesUpdaterSrv ){
				HuesUpdaterSrv.hideHues = true;
				HuesUpdaterSrv.getHues = false;
			}],
			onExit: ['HuesUpdaterSrv', function( HuesUpdaterSrv ){
				HuesUpdaterSrv.hideHues = false;
			}],
			views: {
				'sub-categories@main.categories': {
					templateUrl: 'Filters/Sub-Categories/Views/_sub-categories.html',
					controller: 'SubCategoriesCtrl as subcategories'
				},
				'the-fans@': {
					templateUrl: 'Hues/Main/Views/_the-fans.tpl.html',
					controller: 'FansCtrl as fans'
				},
				'breadcrumbs@main.categories.subcategories': {
					templateUrl: 'Hues/Breadcrumbs/_breadcrumbs.tpl.html',
					controller: 'BreadcrumbsCtrl as breadcrumbs'
				},
				'hues@main.categories.subcategories': {
					templateUrl: 'Hues/Main/Views/_hues.tpl.html',
					controller: 'HuesCtrl as hues'
				}
			},
			resolve: {
				hide: ['category', function( category ){
					return ( category.filter_through === 'categories-select' );
				}],
				sub_category: ['SubcategoriesSrv', 'category', function( SubcategoriesSrv, category ){
					return SubcategoriesSrv.getSubCategories( category.id )
				}],
				family: [function(){ return false; }],
				effect_fan: [function(){ return false; }],
				color_fan: [function(){ return false; }]
			}
		})


		/**
		 * Single States:
		 */

		.state( 'main.categories.families.colors.hue',{
			url: '/hue/:hue_code'
		})
		.state( 'main.categories.families.effects.hue',{
			url: '/hue/:hue_code'
		})
		.state( 'main.categories.families.effects.colors.hue',{
			url: '/hue/:hue_code'
		})
		.state( 'main.categories.subcategories.hue',{
			url: '/hue/:hue_code'
		})


}])